let lockedScrollY = -1;

const scrollHandler = () => {
    window.scrollTo(0, lockedScrollY);
};

export const lockScroll = () => {
    lockedScrollY = window.pageYOffset;

    window.addEventListener('scroll', scrollHandler);
};

export const unlockScroll = () => {
    window.removeEventListener('scroll', scrollHandler);
};
